import { reorderData } from '../../utils/utils';

const initialState = {
  originalOptions: [],
  data: {},
  isOptionsDataSetForPDF: false,
  isAPILoading: false,
  providers: [],
  isTourRequestSuccessful: false,
  showLoading: false,
  majorProviders: [],
};

const optionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ORIGINAL_OPTIONS':
      return {
        ...state,
        originalOptions: action.options,
      };

    case 'SET_DATA':
      return {
        ...state,
        data: { ...action.options },
      };
    case 'SET_MAJOR_PROVIDERS':
      return {
        ...state,
        majorProviders: action.majorProviders,
      };
    case 'SET_API_LOADING':
      return {
        ...state,
        isAPILoading: action.set,
      };

    case 'SET_OPTIONS_DATA_PDF':
      return {
        ...state,
        isOptionsDataSetForPDF: action.set,
      };
    case 'SET_OPTIONS':
      return {
        ...state,
        data: { ...state.data, options: action.options },
      };
    case 'SET_SHOW_LOADING':
      return {
        ...state,
        showLoading: action.loading,
      };
    case 'SET_TOUR_REQUEST':
      return {
        ...state,
        isTourRequestSuccessful: action.isSuccess,
      };
    case 'REORDER_OPTIONS':
      const options = reorderData(action.ids, state.originalOptions)[1];

      return {
        ...state,
        data: { ...state.data, options: options },
      };

    case 'REORDER_BROKER_OPTIONS': {
      const options = action.payload;

      return {
        ...state,
        data: { ...state.data, options },
      };
    }

    case 'SET_ISSHORTLISTED':
      const optionsCopy = state.data.optionProviderRequestList.slice();
      const curr = optionsCopy.find((opt) => opt.id === action.id);

      // curr.isShortlisted = action.val;
      curr.shortListed = action.val;

      return {
        ...state,
        data: { ...state.data, options: optionsCopy },
      };

    default:
      return state;
  }
};

export default optionReducer;
